module.exports = "https://www.svtstatic.se/play/play7/_next/static/images/sprite-b72ad80ec8ff01de271111b9c79e9bf2.png";